import $ from 'jquery/src/jquery'

export default () => {
    const nodeSelectors = {
        container: '[js-popup-gallery-visit-confirmation="container"]',
        close: '[js-popup-gallery-visit-confirmation="close"]',
        open: '[js-popup-gallery-visit-confirmation="open"]',
        btnConfirm: '[js-popup-gallery-visit-confirmation="confirm"]',
        btnCancel: '[js-popup-gallery-visit-confirmation="cancel"]',

        contentDefault: '[js-popup-gallery-visit-confirmation="content-default"]',
        contentCanceled: '[js-popup-gallery-visit-confirmation="content-canceled"]',

        restrictedSingleGalleryPage: $('body.single-gallery').length > 0 && $('.single-gallery-page-container--restricted').length > 0,
    }

    const url = new URL(window.location.href)

    // --- AGE CHECK ON PAGE LOAD ---
    const isRestrictedSingleGalleryPage = nodeSelectors.restrictedSingleGalleryPage
    let targetUrl

    let galleryPage = site_data.site_url + '/gallery/'

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        if (isRestrictedSingleGalleryPage && !url.searchParams.has('ageConfirmed')) {
            open(); // show the popup
        } else {
            const url = new URL(window.location.href)
            if (url.searchParams.has('ageConfirmed')) {
                url.searchParams.delete('ageConfirmed')

                window.history.replaceState({}, document.title, url.pathname + url.search)
            }
        }

        // Allow closing with Escape
        $(document).keyup(function(e) {
            if (e.key === "Escape" && $(nodeSelectors.container).is(':visible') ) {
                close(isRestrictedSingleGalleryPage)
            }
        })

        // Close button
        $(nodeSelectors.close).on('click', function () {
            close(isRestrictedSingleGalleryPage)
        })

        // Click on gallery links
        $(nodeSelectors.open).on('click', function (e) {
            e.preventDefault() // prevent immediate link action
            open()
            targetUrl = $(this).data('js-popup-gallery-visit-confirmation--link')
        })

        // User clicks NO
        $(nodeSelectors.btnCancel).on('click', function () {
            $(nodeSelectors.container).fadeOut(function () {
                openWithCanceledContent()
            })
        })

        // User clicks YES
        $(nodeSelectors.btnConfirm).on('click', function () {
            if( isRestrictedSingleGalleryPage ) {
                if( $(this).data('js-popup-gallery-visit-confirmation--link') ) {
                    targetUrl = $(this).data('js-popup-gallery-visit-confirmation--link')
                }
            }

            if (targetUrl) {
                window.location.href = targetUrl+'?ageConfirmed=true'
            } else {
                // Direct page access — just close popup
                close()
            }
        })
    }

    function close(currentPageIsSingleGallery = false) {
        $(nodeSelectors.container).fadeOut()

        if( currentPageIsSingleGallery ) {
            window.location.href = galleryPage
        }
    }

    function open() {
        $(nodeSelectors.container).fadeIn()
        $(nodeSelectors.contentDefault).show()
        $(nodeSelectors.contentCanceled).hide()
    }

    function openWithCanceledContent() {
        $(nodeSelectors.container).fadeIn()
        $(nodeSelectors.contentDefault).hide()
        $(nodeSelectors.contentCanceled).show()
    }

    return Object.freeze({
        init,
    })
}